import { DashboardWorkbook } from '../../models';
import { DashboardsWorkbookItem } from './dashboards-workbook-item.component';

type DashboardsWorkbooksGridProps = {
  workbooks: DashboardWorkbook[];
  onWorkbookSelect: (workbook: DashboardWorkbook) => void;
};

export const DashboardsWorkbooksGrid = ({
  workbooks,
  onWorkbookSelect,
}: DashboardsWorkbooksGridProps) => (
  <div className="grid grid-cols-3 gap-4">
    {workbooks.map((workbook) => (
      <DashboardsWorkbookItem
        key={workbook.name}
        onWorkbookSelect={() => onWorkbookSelect(workbook)}
        workbook={workbook}
      />
    ))}
  </div>
);
